import React from "react";
import {
  Button,
  Grid,
  IconButton,
  TextField,
  Typography,
} from "@material-ui/core";
import { Delete } from "@material-ui/icons";
import moment from "moment";
import clsx from "clsx";

export default function AdminAction(props) {
  const { classes, handleAdd, handleChange, handleDelete, scaling_actions } =
    props;

  return (
    <Grid container direction="column" spacing={1}>
      <Grid
        item
        container
        alignItems="center"
        justifyContent="space-between"
        className={classes.headerWrapper}
      >
        <Grid item>
          <Typography variant="h6"> Actions </Typography>{" "}
        </Grid>{" "}
        {/* Button: Add New Action */}{" "}
        <Grid item>
          <Button variant="contained" color="primary" onClick={handleAdd}>
            Add Action{" "}
          </Button>{" "}
        </Grid>{" "}
      </Grid>
      <Grid
        item
        container
        direction="column"
        className={clsx({
          [classes.tableWrapper]: scaling_actions.length > 0,
        })}
      >
        {scaling_actions.map((action, index) => (
          <Grid
            key={index}
            item
            container
            alignItems="center"
            justifyContent="space-between"
            className={clsx(classes.actionWrapper, {
              [classes.actionSeperator]: index > 0,
            })}
          >
            <Grid item xs={11} container direction="column">
              {" "}
              {/* TextField: Created At */}{" "}
              <Grid
                item
                container
                alignItems="center"
                justifyContent="space-between"
              >
                <Grid item xs={2} className={classes.label}>
                  <Typography variant="body1" align="right">
                    Created At{" "}
                  </Typography>{" "}
                </Grid>{" "}
                <Grid item xs={10}>
                  <TextField
                    variant="outlined"
                    margin="dense"
                    size="small"
                    fullWidth
                    required
                    id={String(index)}
                    name="created_at"
                    InputProps={{
                      readOnly: true,
                    }}
                    value={moment(action.created_at).format(
                      "dddd, MMMM Do YYYY, h:mm:ss a"
                    )}
                    onChange={handleChange}
                  />{" "}
                </Grid>{" "}
              </Grid>
              {/* TextField: Completed At */}{" "}
              {action.completed_at && (
                <Grid
                  item
                  container
                  alignItems="center"
                  justifyContent="space-between"
                >
                  <Grid item xs={2} className={classes.label}>
                    <Typography variant="body1" align="right">
                      Completed At{" "}
                    </Typography>{" "}
                  </Grid>{" "}
                  <Grid item xs={10}>
                    <TextField
                      variant="outlined"
                      margin="dense"
                      size="small"
                      fullWidth
                      required
                      id={String(index)}
                      name="completed_at"
                      InputProps={{
                        readOnly: true,
                      }}
                      value={moment(action.completed_at).format(
                        "dddd, MMMM Do YYYY, h:mm:ss a"
                      )}
                      onChange={handleChange}
                    />{" "}
                  </Grid>{" "}
                </Grid>
              )}
              {/* TextField: Actions */}{" "}
              <Grid
                item
                container
                alignItems="center"
                justifyContent="space-between"
              >
                <Grid item xs={2} className={classes.label}>
                  <Typography variant="body1" align="right">
                    Actions{" "}
                  </Typography>{" "}
                </Grid>{" "}
                <Grid item xs={10}>
                  <TextField
                    variant="outlined"
                    margin="dense"
                    size="small"
                    fullWidth
                    required
                    multiline
                    rows={6}
                    id={String(index)}
                    name="actions"
                    value={action.actions}
                    onChange={handleChange}
                    helperText="Not more than 1000 characters"
                  />
                </Grid>{" "}
              </Grid>
              {/* TextField: Action Status */}{" "}
              <Grid
                item
                container
                alignItems="center"
                justifyContent="space-between"
              >
                <Grid item xs={2} className={classes.label}>
                  <Typography variant="body1" align="right">
                    Status{" "}
                  </Typography>{" "}
                </Grid>{" "}
                <Grid item xs={10}>
                  <TextField
                    variant="outlined"
                    margin="dense"
                    size="small"
                    fullWidth
                    required
                    select
                    SelectProps={{
                      native: true,
                    }}
                    id={String(index)}
                    name="status"
                    value={action.status}
                    onChange={handleChange}
                  >
                    {["PENDING", "COMPLETE"].map((value, index) => (
                      <option key={index} value={value}>
                        {" "}
                        {value}{" "}
                      </option>
                    ))}{" "}
                  </TextField>{" "}
                </Grid>{" "}
              </Grid>{" "}
            </Grid>
            {/* Button: Delete Actions */}{" "}
            <Grid item xs={1} className={classes.buttonWrapper}>
              <IconButton onClick={() => handleDelete(action.action_id)}>
                <Delete color="error" />
              </IconButton>{" "}
            </Grid>{" "}
          </Grid>
        ))}{" "}
      </Grid>{" "}
    </Grid>
  );
}
